<template>
  <Tabs
    v-model="model"
    :default-value="defaultValue"
    :class="cn('tw-flex tw-flex-col tw-min-h-0', props.class)"
  >
    <div
      :class="
        cn(
          'tw-flex tw-items-end tw-gap-0 tw-shrink-0 tw-overflow-x-auto tw-border-b tw-border-surface-200 dark:tw-border-neutral-800',
          listClass
        )
      "
    >
      <TabsList
        class="tw-h-auto tw-w-full !tw-justify-start tw-gap-1 tw-rounded-none tw-bg-transparent tw-p-0"
      >
        <TabsTrigger
          v-for="tab in tabs"
          :key="tab.value"
          :value="tab.value"
          :disabled="tab.disabled"
          class="tw-relative tw-rounded-none tw-border-0 tw-bg-transparent tw-px-3.5 tw-py-3 tw-text-[0.9rem] tw-font-medium tw-tracking-tight tw-text-surface-500 tw-shadow-none tw-transition-colors hover:tw-text-secondary-700 data-[state=active]:tw-bg-transparent data-[state=active]:tw-text-secondary-900 data-[state=active]:tw-shadow-none dark:tw-text-neutral-400 dark:hover:tw-text-neutral-200 dark:data-[state=active]:tw-text-neutral-50 after:tw-absolute after:tw-bottom-[-1px] after:tw-left-2 after:tw-right-2 after:tw-h-[2.5px] after:tw-rounded-full after:tw-bg-transparent after:tw-transition-colors data-[state=active]:after:tw-bg-secondary-700 dark:data-[state=active]:after:tw-bg-primary-400 data-[state=active]:tw-font-semibold"
        >
          <span class="tw-inline-flex tw-items-center tw-gap-1.5">
            {{ tab.label }}
            <span
              v-if="tab.dot"
              class="tw-inline-block tw-h-1.5 tw-w-1.5 tw-rounded-full tw-bg-primary-500"
              aria-hidden="true"
            />
          </span>
        </TabsTrigger>
      </TabsList>
      <slot name="trailing" />
    </div>

    <TabsContent
      v-for="tab in tabs"
      :key="tab.value"
      :value="tab.value"
      :class="
        cn('tw-flex-1 tw-min-h-0 tw-mt-0 tw-outline-none tw-overflow-y-auto tw-pr-3', contentClass)
      "
    >
      <slot :name="tab.value" />
    </TabsContent>
  </Tabs>
</template>

<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

export interface AlascoUnderlineTab {
  value: string;
  label: string;
  disabled?: boolean;
  /** Show a small unread/attention dot next to the label. */
  dot?: boolean;
}

interface Props {
  tabs: AlascoUnderlineTab[];
  defaultValue?: string;
  class?: HTMLAttributes['class'];
  listClass?: HTMLAttributes['class'];
  contentClass?: HTMLAttributes['class'];
}

const props = withDefaults(defineProps<Props>(), {
  defaultValue: undefined,
});

const model = defineModel<string>();
</script>
